// Formato es-CO compartido del mundo directivo (Dashboard, Líneas, drill).

export function miles(n: number): string {
  return new Intl.NumberFormat('es-CO').format(Math.round(n));
}

export function copM(n: number): string {
  if (Math.abs(n) >= 1_000_000) {
    const m = n / 1_000_000;
    return `$${m.toLocaleString('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} M`;
  }
  return `$${miles(n)}`;
}

/** Compacto para espacios angostos: 117.557 → "117,6 k". */
export function compacto(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1_000_000)
    return `${(n / 1_000_000).toLocaleString('es-CO', { maximumFractionDigits: 1 })} M`;
  if (abs >= 1_000) return `${(n / 1_000).toLocaleString('es-CO', { maximumFractionDigits: 1 })} k`;
  return miles(n);
}

export function pctEntero(num: number, den: number): number | null {
  return den > 0 ? Math.round((num / den) * 100) : null;
}

export function horasMin(min: number): string {
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return `${h}h ${String(m).padStart(2, '0')}m`;
}
